import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export const PreviewShare: React.FC = () => {
  const location = useLocation();
  
  // Get query parameters
  const searchParams = new URLSearchParams(location.search);
  const branchUrl = searchParams.get('branch_link') || '';
  const previewUrl = searchParams.get('image') || '';
  
  // Format a display URL (for showing in previews)
  const displayUrl = branchUrl.replace(/https?:\/\//i, '');
  
  return (
    <>
      <Helmet>
        <title>Preview | {displayUrl}</title>
        {/* OpenGraph meta tags for social sharing */}
        <meta property="og:title" content={`Open Item: ${displayUrl}`} />
        <meta property="og:description" content={`Open this link to view the item: ${displayUrl}`} />
        {previewUrl && <meta property="og:image" content={previewUrl} />}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        
        {/* Twitter card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Open Item: ${displayUrl}`} />
        <meta name="twitter:description" content={`Open this link to view the item: ${displayUrl}`} />
        {previewUrl && <meta name="twitter:image" content={previewUrl} />}
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <div className="max-w-2xl w-full bg-white rounded-lg shadow-md overflow-hidden">
          {previewUrl ? (
            <img 
              src={previewUrl} 
              alt="Preview" 
              className="w-full h-auto"
            />
          ) : (
            <div className="bg-gray-200 h-64 flex items-center justify-center">
              <p className="text-gray-500">No preview image available</p>
            </div>
          )}
          
          <div className="p-4">
            <h1 className="text-xl font-semibold mb-4">Item Preview</h1>
            
            {branchUrl && (
              <div className="mb-4">
                <p className="text-gray-700 mb-2">View the item at:</p>
                <a 
                  href={branchUrl}
                  className="text-blue-600 hover:underline break-all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {branchUrl}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}; 